import React from 'react';
import { useLanguage } from './LanguageContext';
import { Baby, User, Users, Heart } from 'lucide-react';
export function WhoWeHelp() {
  const {
    t
  } = useLanguage();
  const groups = [{
    name: t('who.children'),
    icon: <Baby className="w-6 h-6" data-id="element-217" />,
    color: 'bg-blue-100 text-blue-700'
  }, {
    name: t('who.adolescents'),
    icon: <User className="w-6 h-6" data-id="element-218" />,
    color: 'bg-teal-100 text-teal-700'
  }, {
    name: t('who.adults'),
    icon: <Users className="w-6 h-6" data-id="element-219" />,
    color: 'bg-purple-100 text-purple-700'
  }, {
    name: t('who.families'),
    icon: <Heart className="w-6 h-6" data-id="element-220" />,
    color: 'bg-pink-100 text-pink-700'
  }];
  return <section className="py-16 bg-brand-light" data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-223">
          <div className="md:w-1/3" data-id="element-224">
            <h2 className="text-3xl font-bold text-brand-deep mb-4" data-id="element-225">
              {t('who.title')}
            </h2>
            <p className="text-gray-600" data-id="element-226">
              We provide specialized care for patients of all ages, ensuring
              that every member of our community has access to quality mental
              health support.
            </p>
          </div>

          <div className="md:w-2/3 grid grid-cols-2 md:grid-cols-4 gap-4 w-full" data-id="element-227">
            {groups.map((group, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm flex flex-col items-center justify-center text-center gap-3 hover:shadow-md transition-shadow" data-id="element-228">
                <div className={`p-3 rounded-full ${group.color}`} data-id="element-229">
                  {group.icon}
                </div>
                <span className="font-semibold text-gray-800" data-id="element-230">
                  {group.name}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}